import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { CountryModel } from './../../models/country.model';
import { CountryService } from './../../services/country.service';
import { FilterCountries } from './../action/country.action';

export interface CountryStateModel {
  countries: CountryModel[];
}

@State<CountryStateModel>({
  name: 'countrystate',
  defaults: {
    countries: [],
  },
})
@Injectable()
export class CountryState {
  constructor(private countryService: CountryService) {}

  @Selector()
  static countries(ctx: CountryStateModel) {
    return ctx.countries;
  }

  @Action(FilterCountries)
  async filterCountries(
    ctx: StateContext<CountryStateModel>,
    action: FilterCountries
  ) {
    const data = await this.countryService.getAll().toPromise();

    ctx.patchState({
      countries: data,
    });
  }
}
